import { default as content } from '../AddNewPayeeLandingPage/index.content';
import withValidation from '../../../containers/withValidation';
import { Select, Input, GenericTextArea } from '../../../sharedComponents/Form';
import withBackEndError from '../../../containers/withBackEndError';

const {
	nameErrorMessage,
	sortCodeErrorMessage,
	accountNumberErrorMessage,
	referenceErrorMessage,
	displayNameErrorMessage,
	payeeAddressLine1ErrorMessage,
	payeeCityErrorMessage,
	payeeCountryErrorMessage,
	chapsPayeeNameMaxlengthError,
	chapsReferenceError,
	otherPaymentReferenceRequiredError,
	referenceInvalidCharsErrorMessage,
	swiftReferenceInvalidCharsErrorMessage,
} = content;

export const NameInput = withValidation({
	validations: ['required', 'isPayeeName', 'chapsMaxLength'],
	key: 'name',
	message: { required: nameErrorMessage, chapsMaxLength: chapsPayeeNameMaxlengthError, isPayeeName: nameErrorMessage },
})(Input);
export const SortCodeInput = withValidation({
	validations: ['required', 'sortCode'],
	key: 'sortCode',
	message: sortCodeErrorMessage,
})(withBackEndError(Input));
export const AccountNumberInput = withValidation({
	validations: ['required', 'accountNumber'],
	key: 'accountNumber',
	message: accountNumberErrorMessage,
})(withBackEndError(Input));
export const ReferenceInput = withValidation({
	validations: ['required', 'isPayeeName'],
	key: 'reference',
	message: { required: referenceErrorMessage, isPayeeName: referenceInvalidCharsErrorMessage },
})(Input);
export const ChapsReferenceInput = withValidation({
	validations: ['maxLength', 'swiftMultiChar'],
	key: 'chapsReference',
	message: { maxLength: chapsReferenceError, swiftMultiChar: swiftReferenceInvalidCharsErrorMessage },
})(GenericTextArea);
export const OtherPaymentReferenceInput = withValidation({
	validations: ['required'],
	key: 'otherPaymentReference',
	message: otherPaymentReferenceRequiredError,
})(Input);
export const DisplayNameInput = withValidation({
	validations: ['required'],
	key: 'displayName',
	message: displayNameErrorMessage,
})(Input);
export const PayeeAddressLine1 = withValidation({
	validations: ['required', 'swift'],
	key: 'payeeAddressLine1',
	message: payeeAddressLine1ErrorMessage,
})(Input);
export const PayeeCity = withValidation({
	validations: ['required', 'swift'],
	key: 'payeeCity',
	message: payeeCityErrorMessage,
})(Input);
export const PayeeCountry = withValidation({
	validations: ['required'],
	key: 'payeeCountry',
	message: payeeCountryErrorMessage,
})(Select);
export const CopType = withValidation({
	validations: ['required'],
	key: 'copType',
	message: 'type is required',
})(Input);
